import React, { useState, useEffect } from "react";
import { TableCell, TableRow, Tooltip, Box } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { makeStyles } from '@material-ui/core/styles';
import { checkPermission } from '../../utils_v2';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditIcon from '@material-ui/icons/Edit';
import { getPermissionKey } from "..";
import { numberWithCommas } from '../../../utils';
import { hanwahaInstance } from "../../../shared/components";

// Static Operated Cycles column, only for Hanwha engine slugs nrXdTj[Prod] (Primary LLP tab listing, not add/edit)
export const staticOperatedThrust = { engine_thrust_name: '7B27/B3', csn: 5475 };
export const showStaticOperatedThrust = (params, tabIndex, editField) => hanwahaInstance && !editField && params?.type === 'engine' && tabIndex == '0' && ['nrXdTj', 'VkPXhA'].includes(params?.aircraft_slug);

const InformationIcon = ({ item }) => {
    return (item?.is_hourly_based === true && (
        <Tooltip title="FH" arrow >
            <InfoIcon style={{ fontSize: '15px' }} color="primary" fontSize="small" />
        </Tooltip>
    ))
}

export const EngineLlpList = ({ item, editField, onFieldChange, sheetError, setSheetError, onResetError, params, onDelete, onEdit, thurstInfo, tabIndex, oldFlow, haveSecondaryLlpThrust }) => {
    const useStyles = makeStyles({
        hoverRow: {
            backgroundColor: item?.is_hourly_based === true ? '#fff1b6 !important' : 'inherit',
            "&.MuiTableRow-hover:hover": {
                backgroundColor: item?.is_hourly_based === true ? "#fff9df !important" : 'inherit',
            },
        }
    });
    const classes = useStyles({ isHourly: item?.is_hourly_based === true });
    const [showMore, setShowMore] = useState({});
    const StatusCode = item.part_numbers_dropdown?.filter((option => option.part_number === item?.part_number))[0]?.status;
    const modules = [{ label: 'FAN', value: 1 }, { label: 'HPC', value: 2 }, { label: 'HPT', value: 4 }, { label: 'LPT', value: 5 }, { label: 'Gearboxes', value: 6 }, { label: 'Combustion', value: 3 }, { label: 'IPC', value: 8 }, { label: 'IPT', value: 9 }, { label: 'Compressor', value: 10 }, { label: 'Cold Section', value: 11 }, { label: 'Hot Section', value: 12 }, { label: 'Power Turbine', value: 13 }, { label: 'Others', value: 7 }]
    const toggleDescription = (field) => {
        setShowMore({
            ...showMore,
            [field]: !showMore[field],
        });
    };
    const calculateWidth = (minWidth, maxWidth, content, minCount, maxCount) => {
        let width = 50;
        if (content?.length < minCount) {
            width = minWidth;
        } else if (content?.length > minCount) {
            width = maxWidth;
        }

        return `${width}px`;
    }

    return (
        <TableRow className={classes.hoverRow} hover>
            <TableCell>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <div style={{ minWidth: '120px', maxWidth: '180px' }}>{item?.module || "--"}</div>
                    <InformationIcon item={item} />
                </Box>
            </TableCell>
            <TableCell>
                {item?.description && item?.description?.length > 25 ? (
                    <div >
                        {showMore[item?.field] ? (
                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                <span> {item?.description}
                                    <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }}  > less </a>
                                </span>
                                <InformationIcon item={item} />
                            </Box>
                        ) : (
                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                <span> {item.description.substring(0, 20)}
                                    <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }}  > ..more </a>
                                </span>
                                <InformationIcon item={item} />
                            </Box>
                        )}
                    </div>
                ) : (
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        <span><div style={{ minWidth: '160px', maxWidth: '200px' }}>{item.description ? item.description : "--"}</div></span>
                        <InformationIcon item={item} />
                    </Box>

                )}
            </TableCell>
            <TableCell>{
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <div style={{ minWidth: '70px', maxWidth: '180px' }}>{item?.part_number || "--"}</div>
                    <InformationIcon item={item} />
                </Box>
            }
            </TableCell>
            <TableCell>{
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <div style={{ minWidth: '130px', maxWidth: '180px' }}>{item?.serial_number || '--'}</div>
                    <InformationIcon item={item} />
                </Box>}
            </TableCell>
            <TableCell>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <div style={{ minWidth: '80px', maxWidth: '180px' }}> {item?.tsn ? numberWithCommas((item?.tsn).toFixed(2)) : '--'}</div>
                    <InformationIcon item={item} />
                </Box>
            </TableCell>
            <TableCell>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    {numberWithCommas(item?.csn)}
                    <InformationIcon item={item} />
                </Box>
            </TableCell>
            {(tabIndex != "0" && (tabIndex == '1' && !haveSecondaryLlpThrust)) || oldFlow ?
                <TableCell>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        {numberWithCommas(item?.cycles_max_limit)}
                        <InformationIcon item={item} />
                    </Box>
                </TableCell> :
                thurstInfo?.map((thrust, index) => (
                    <TableCell>
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                            {
                                (() => {
                                    const value = item?.is_hourly_based === true
                                        ? item?.operated_cycles_thrusts
                                            ?.find(ele => ele.id == thrust?.id)
                                            ?.tsn
                                        : item?.operated_cycles_thrusts
                                            ?.find(ele => ele.id == thrust?.id)
                                            ?.csn;

                                    return value === null || value === undefined || value === ""
                                        ? (tabIndex == '1' && haveSecondaryLlpThrust ? 0 : '0')
                                        : numberWithCommas(value);
                                })()
                            }
                            <InformationIcon item={item} />
                        </Box>
                    </TableCell>
                ))}
            {(tabIndex != "0" && (tabIndex == '1' && !haveSecondaryLlpThrust)) || oldFlow || !showStaticOperatedThrust(params, tabIndex, editField) ? null :
                <TableCell>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        {numberWithCommas(staticOperatedThrust.csn)}
                        <InformationIcon item={item} />
                    </Box>
                </TableCell>}
            {(tabIndex != "0" && (tabIndex == '1' && !haveSecondaryLlpThrust)) || oldFlow ?
                <TableCell>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        {numberWithCommas(item?.cycles_remaining)}
                        <InformationIcon item={item} />
                    </Box>
                </TableCell> :
                thurstInfo?.map((thrust, index) => (
                    <TableCell>
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                            {
                                (() => {
                                    const value = item?.cycles_max_limit_thrusts?.find(item => item.id == thrust?.id)?.cycles_max_limit
                                    return value === null || value === undefined || value === ""
                                        ? (tabIndex == '1' && haveSecondaryLlpThrust) ? 0 : "0"
                                        : numberWithCommas(value);
                                })()
                            }
                            <InformationIcon item={item} />
                        </Box>
                    </TableCell>
                ))}
            {(tabIndex != "0" && (tabIndex == '1' && !haveSecondaryLlpThrust)) || oldFlow ? null :
                thurstInfo?.map((thrust, index) => (
                    <TableCell >
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                            {
                                (() => {
                                    const value =
                                        item?.cycles_remaining_thrusts
                                            ?.find(item => item.id == thrust?.id)
                                            ?.cycles_remaining;
                                    return value === null || value === undefined || value === ""
                                        ? (tabIndex == '1' && haveSecondaryLlpThrust) ? 0 : "0"
                                        : numberWithCommas(value);
                                })()
                            }
                            <InformationIcon item={item} />
                        </Box>
                    </TableCell>
                ))}
            <TableCell>{
                (item?.remarks && item?.remarks?.length > 25 ? (
                    <div style={{ width: calculateWidth('100', '142', item?.remarks, '25', '') }}>
                        {showMore[item?.field] ? (
                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                <span> {item?.remarks}
                                    <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }}  > less </a>
                                </span>
                                <InformationIcon item={item} />
                            </Box>
                        ) : (
                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                <span> {item.remarks.substring(0, 20)}
                                    <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }}  > ..more </a>
                                </span>
                                <InformationIcon item={item} />
                            </Box>
                        )}
                    </div>
                ) : (
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        <span>{item.remarks || '--'}</span>
                        <InformationIcon item={item} />
                    </Box>
                ))}
            </TableCell>
            {!editField ?
                <TableCell>
                    {checkPermission('technical_specs', getPermissionKey(params.type), 'U') ?
                        <ul className="list-inline" style={{ textAlign: 'center' }}>
                            {(tabIndex == '1' && !haveSecondaryLlpThrust) || oldFlow ? null : <li className="list-inline-item hover-inline " onClick={onEdit}> <Tooltip title='Edit' arrow><EditIcon color="primary" fontSize="small" /></Tooltip></li>}
                            <li className="list-inline-item hover-inline " onClick={onDelete}> <Tooltip title='Delete' arrow><DeleteOutlineIcon color="secondary" fontSize="small" /></Tooltip></li>
                        </ul>
                        : null}
                </TableCell>
                : null}
        </TableRow>
    )
}

